var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"history-snackbars"}},[_c('UndoSnackbar',{attrs:{"timeout":8000,"header":_vm.displayedAction.header,"message":_vm.displayedAction.message},on:{"undo":_vm.undoAction,"close":_vm.close},model:{value:(_vm.showAction),callback:function ($$v) {_vm.showAction=$$v},expression:"showAction"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }